function ContrastError() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Very low contrast between text and background colors.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Adequate contrast of text is necessary for all users, especially users with low vision.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Increase the contrast between the foreground (text) color and the background color. Large text (larger than 18 point or 14 point bold) does not require as much contrast as smaller text.</p>
    </blockquote>
  )
}

export default ContrastError